// const getMenuListApplicableForSupport = (menuResponse = []) => {
//   const excluded = ["Ticket Summary"];

//   return [
//     ...menuResponse
//       .filter(
//         (menu) =>
//           menu?.menuDisplayName && !excluded.includes(menu.menuDisplayName),
//       )
//       .map((menu) => menu.menuDisplayName),
//     "Others",
//   ];
// };
const getMenuListApplicableForSupport = (menuResponse) => {
  console.log("menuResponse", menuResponse);
  const excluded = ["Ticket Summary"];

  const menuList = Array.isArray(menuResponse) ? menuResponse : [];

  return [
    ...menuList
      .filter(
        (menu) =>
          menu?.menuDisplayName && !excluded.includes(menu.menuDisplayName),
      )
      .map((menu) => menu.menuDisplayName),
    "Others",
  ];
};

// const getSubmenuListForMenu = (menuResponse, selectedMenu) => {
//   const menu = menuResponse.find((m) => m.menuDisplayName === selectedMenu);

//   if (!menu || !Array.isArray(menu.submenuList)) return [];

//   return menu.submenuList
//     .filter(
//       (sub) =>
//         sub &&
//         typeof sub.submenuDisplayName === "string" &&
//         sub.submenuDisplayName.trim() !== "" &&
//         sub.submenuPath,
//     )
//     .map((sub) => sub.submenuDisplayName);
// };

const getSubmenuListForMenu = (menuResponse, selectedMenu) => {
  console.log("menuResponse", menuResponse);
  const menuList = Array.isArray(menuResponse) ? menuResponse : [];

  const menu = menuList.find(
    (m) => m.menuDisplayName === selectedMenu,
  );

  if (!menu || !Array.isArray(menu.submenuList)) return [];

  return menu.submenuList
    .filter(
      (sub) =>
        sub &&
        typeof sub.submenuDisplayName === "string" &&
        sub.submenuDisplayName.trim() !== "" &&
        sub.submenuPath,
    )
    .map((sub) => sub.submenuDisplayName);
};

const DEFAULT_ADDITIONAL_FIELDS = {
  bottler: false,
  forecastPartner: false,
  plant: false,
  profitCenter: false,
};

const getApplicableAdditionalFields = (menu, subMenu) => {
  if (!menu) return DEFAULT_ADDITIONAL_FIELDS;

  const normalizedMenu = menu.trim().toLowerCase();
  const normalizedSubMenu = subMenu ? subMenu.trim().toLowerCase() : null;

  const menuDetail = supportMenuDetailList.find((item) => {
    if (!item.menu) return false;

    const configMenu = item.menu.trim().toLowerCase();
    const configSubMenu = item.subMenu?.trim().toLowerCase();

    const menuMatches =
      configMenu === normalizedMenu ||
      normalizedMenu.includes(configMenu) ||
      configMenu.includes(normalizedMenu);

    if (!menuMatches) return false;

    if (configSubMenu) {
      return (
        configSubMenu === normalizedSubMenu ||
        normalizedSubMenu?.includes(configSubMenu) ||
        configSubMenu.includes(normalizedSubMenu)
      );
    }

    return true;
  });

  return {
    ...DEFAULT_ADDITIONAL_FIELDS,
    ...(menuDetail?.additionalFields || {}),
  };
};

const getCategoryList = (menu, subMenu) => {
  if (!menu) return [];

  const menuDetail = supportMenuDetailList.find((item) => {
    if (!item.subMenu && !subMenu) {
      return item.menu === menu;
    }

    return item.menu === menu && item.subMenu === subMenu;
  });

  return menuDetail ? menuDetail.categories.map((cat) => cat.category) : [];
};

const getFunctionalityList = (menu, subMenu, category) => {
  if (!menu || !category) return [];

  const menuDetail = supportMenuDetailList.find((item) => {
    if (!item.subMenu && !subMenu) {
      return item.menu === menu;
    }
    return item.menu === menu && item.subMenu === subMenu;
  });

  if (!menuDetail) return [];

  const categoryDetail = menuDetail.categories.find(
    (item) => item.category === category,
  );

  return categoryDetail ? categoryDetail.functionalities : [];
};

const supportMenuDetailList = [
  // ===== Bottler Concentrate Forecast =====
  {
    menu: "Bottler Concentrate Forecast",
    subMenu: "Dashboard",
    categories: [
      {
        category: "Bottler Forecast Upload Dashboard",
        functionalities: ["Blank Page"],
      },
      {
        category: "Forecast Upload Status",
        functionalities: [
          "Submission Status",
          "Forecast deadline",
          "Forecast Term- Short Term",
          "Forecast term- Long Term",
        ],
      },
      {
        category: "Bottler Selection",
        functionalities: [
          "Forecast partner dropdown and selection",
          "Plant dropdown and selection",
          "Search",
          "Bottler dropdown and selection",
        ],
      },
      {
        category: "Previous Forecast Uploads",
        functionalities: [
          "View all history",
          "Upload Status",
          "Upload record Count",
          "View Button",
        ],
      },
      {
        category: "Record detail",
        functionalities: [
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: true,
      profitCenter: false,
    },
  },
  {
    menu: "Bottler Concentrate Forecast",
    subMenu: "History",
    categories: [
      {
        category: "Forecast History",
        functionalities: [
          "Upload Status",
          "Upload record Count",
          "View Button",
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: true,
      profitCenter: false,
    },
  },
  {
    menu: "Bottler Concentrate Forecast",
    subMenu: "Metrics",
    categories: [
      {
        category: "Forecast Tracker",
        functionalities: [
          "Forecast term dropdown",
          "Forecast period dropdown",
          "Forecast Submission status",
          "Plant view button",
          "Bottler view button",
          "% button",
          "Count button",
          "Forecast submission by plant drill down",
          "Forecast submission by bottler drill down",
        ],
      },
      {
        category: "Performance History",
        functionalities: [
          "Forecast term dropdown",
          "Forecast period dropdown",
          "Forecast Submission status",
          "Plant view button",
          "Bottler view button",
          "% button",
          "Count button",
          "Forecast submission by plant drill down",
          "Forecast submission by bottler drill down",
          "Forecast submission by Month",
        ],
      },
      {
        category: "Error Performance",
        functionalities: [
          "Forecast term dropdown",
          "Forecast period dropdown",
          "Plant view button",
          "Bottler view button",
          "Most Frequent Errors",
          "Count button",
          "Error Performance details by Plant",
          "Error Performance details by Bottler",
        ],
      },
    ],
    additionalFields: {},
  },
  {
    menu: "Bottler Concentrate Forecast",
    subMenu: "Manage Forecast",
    categories: [
      {
        category: "Standard Coke Template",
        functionalities: [
          "Forecast term dropdown",
          "Forecast Period dropdown",
          "Bottler selection search",
          "Bottler selection dropdown",
          "Download Template",
          "Upload Template",
        ],
      },
      {
        category: "Custom Coke Template",
        functionalities: [
          "Forecast term dropdown",
          "Forecast Period dropdown",
          "Bottler selection search",
          "Bottler selection dropdown",
          "Upload Template",
        ],
      },
      {
        category: "Template Configuration",
        functionalities: [
          "Set Column Positions by File Upload",
          "Template Configuration Selection",
          "Template Configuration Save",
          "Template Configuration Delete",
        ],
      },
      {
        category: "Manual Update",
        functionalities: ["Manual Update Save"],
      },
      {
        category: "Excel Update",
        functionalities: ["Excel Download", "Excel Upload"],
      },
    ],
    additionalFields: {},
  },
  //Bottler Market Forecast
  {
    menu: "Bottler Market Forecast",
    subMenu: "Dashboard",
    categories: [
      {
        category: "Bottler Forecast Upload Dashboard",
        functionalities: ["Blank Page"],
      },
      {
        category: "Forecast Upload Status",
        functionalities: ["Submission Status"],
      },
      {
        category: "Bottler Selection",
        functionalities: [
          "Bottler owner code selection",
          "Country dropdown and selection",
          "Search",
          "Bottler dropdown and selection",
        ],
      },
      {
        category: "Previous Forecast Uploads",
        functionalities: [
          "View all history",
          "Upload Status",
          "Upload record Count",
          "View Button",
        ],
      },
      {
        category: "Record detail",
        functionalities: [
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Bottler Market Forecast",
    subMenu: "History",
    categories: [
      {
        category: "Forecast History",
        functionalities: [
          "Upload Status",
          "Upload record Count",
          "View Button",
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Bottler Market Forecast",
    subMenu: "Metrics",
    categories: [
      {
        category: "Forecast Tracker",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "Forecast Submission status",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
        ],
      },
      {
        category: "Performance History",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
          "Forecast submission by Month",
        ],
      },
      // {
      //   category: "Error Performance",
      //   functionalities: [
      //     "Forecast period dropdown",
      //     "Bottler dropdown",
      //     "Country dropdown",
      //     "Region dropdown",
      //     "Most Frequent Errors",
      //     "Error Performance details by Bottler",
      //   ],
      // },
    ],
    additionalFields: {},
  },
  {
    menu: "Bottler Market Forecast",
    subMenu: "Manage Forecast",
    categories: [
      {
        category: "Standard Coke Template",
        functionalities: [
          "Forecast Period dropdown",
          "Bottler selection search",
          "Bottler selection dropdown",
          "Download Template",
          "Upload Template",
        ],
      },
      // {
      //   category: "Custom Coke Template",
      //   functionalities: [
      //     "Forecast Period dropdown",
      //     "Bottler selection search",
      //     "Bottler selection dropdown",
      //     "Upload Template",
      //   ],
      // },
      // {
      //   category: "Template Configuration",
      //   functionalities: [
      //     "Set Column Positions by File Upload",
      //     "Template Configuration Selection",
      //     "Template Configuration Save",
      //     "Template Configuration Delete",
      //   ],
      // },
      // {
      //   category: "Manual Update",
      //   functionalities: ["Manual Update Save"],
      // },
      // {
      //   category: "Excel Update",
      //   functionalities: ["Excel Download", "Excel Upload"],
      // },
    ],
    additionalFields: {},
  },
  // ===== Admin Panel =====
  {
    menu: "Admin Panel",
    subMenu: "Manage User",
    categories: [
      {
        category: "User Management",
        functionalities: [
          "User Name",
          "email address",
          "Roles",
          "Delete user",
          "Edit user",
        ],
      },
      {
        category: "Add User",
        functionalities: [
          "Roles Dropdown and selection",
          "Search Button",
          "Add User",
          "Email Only",
          "Save",
        ],
      },
      {
        category: "User detail",
        functionalities: [
          "Edit Email",
          "Bottler dropdown and selection",
          "Forecast partner dropdown and selection",
          "Plant dropdown and selection",
          "Bottler owner code selection",
          "Multi selection",
          "Bulk notification checkbox",
          "Notification ON/OFF",
          "Enable",
          "disable",
        ],
      },
    ],
    additionalFields: {},
  },
  {
    menu: "Admin Panel",
    subMenu: "Bottler Onboarding",
    categories: [
      {
        category: "Bottler Configuration",
        functionalities: [
          "Active ON/OFF",
          "Forecast partner Configuration edit button",
        ],
      },
      {
        category: "Forecast partner Configuration",
        functionalities: [
          "Forecast Partner",
          "Short term duration",
          "Long term duration",
          "Plant Configuration Edit",
          "Save",
        ],
      },
      {
        category: "Plant Configuration",
        functionalities: [
          "Rolling week Submission enable checkbox",
          "Forecast duration",
          "Flexible long term enable checkbox",
          "Submission frequency",
          "Effective period dropdown and selection",
          "save",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: true,
      profitCenter: false,
    },
  },
  {
    menu: "Profit Center",
    subMenu: null,
    categories: [
      {
        category: "Profit center selection",
        functionalities: [
          "Region",
          "Profit center dropdown and selection",
          "Save button",
          "Last updated by",
          "Remarks",
          "Download",
        ],
      },
      {
        category: "Enter Remarks for Changing Profit Center",
        functionalities: ["Remarks and save"],
      },
    ],
    additionalFields: {},
  },
  {
    menu: "Admin Panel",
    subMenu: "Access Management",
    categories: [
      {
        category: "Access Request",
        functionalities: [
          "Environment dropdown selection",
          "Request Type dropdown selection",
          "IBP Business Role dropdown",
          "Permission Filter dropdown",
          "Bottler dropdown selection",
          "Country dropdown selection",
          "Customer dropdown selection",
          "Plant dropdown selection",
          "AD Group Role dropdown",
          "AD Process Type dropdown",
          "Submit button",
          "Clear button",
          "Bulk Upload",
          "Download",
        ],
      },
      {
        category: "Access Tracker",
        functionalities: ["Ticket Status", "View Details"],
      },
    ],
  },
  {
    menu: "Admin Panel",
    subMenu: "Reminder Configuration",
    categories: [
      {
        category: "Reminder Setup",
        functionalities: [
          "Data Elements dropdown selection",
          "Forecast Term dropdown selection",
          "Reminder Period dropdown selection",
          "Number of Days input",
          "Roles dropdown selection",
          "Email Recipients input",
          "Submit reminder configuration",
        ],
      },
      {
        category: "View Reminder Details",
        functionalities: ["View reminder configuration details"],
      },
      {
        category: "Edit Reminder",
        functionalities: [
          "Edit Data Elements",
          "Edit Forecast Term",
          "Edit Reminder Period",
          "Edit Number of Days",
          "Edit Roles",
          "Edit Email Recipients",
          "Update reminder configuration",
        ],
      },
      {
        category: "Delete Reminder",
        functionalities: [
          "Select reminder record",
          "Delete reminder configuration",
        ],
      },
    ],
  },
  {
    menu: "Admin Panel",
    subMenu: "Report",
    categories: [],
    additionalFields: {},
  },
  //FG Inventory
  {
    menu: "FG Inventory",
    subMenu: "Dashboard",
    categories: [
      {
        category: "FG Inventory Upload Dashboard",
        functionalities: ["Blank Page"],
      },
      {
        category: "FG Inventory Upload Status",
        functionalities: ["Submission Status"],
      },
      {
        category: "Bottler Selection",
        functionalities: [
          "Bottler owner code selection",
          "Country dropdown and selection",
          "Search",
          "Bottler dropdown and selection",
        ],
      },
      {
        category: "Previous FG Inventory Uploads",
        functionalities: [
          "View all history",
          "Upload Status",
          "Upload record Count",
          "View Button",
        ],
      },
      {
        category: "Record detail",
        functionalities: [
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "FG Inventory",
    subMenu: "History",
    categories: [
      {
        category: "FG Inventory History",
        functionalities: [
          "Upload Status",
          "Upload record Count",
          "View Button",
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "FG Inventory",
    subMenu: "Target Days of Supply",
    categories: [
      {
        category: "FG Inventory Target Days of Supply",
        functionalities: [
          "Bottler Owner Code dropdown",
          "Target Days of Supply input field",
          "Status column",
          "Save button",
          "Download button",
          "Upload button",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "FG Inventory",
    subMenu: "Manage FG Inventory",
    categories: [
      {
        category: "Standard Coke Template",
        functionalities: [
          "FG Inventory Period dropdown",
          "Bottler selection search",
          "Bottler selection dropdown",
          "Download Template",
          "Upload Template",
        ],
      },
      // {
      //   category: "Custom Coke Template",
      //   functionalities: [
      //     "Forecast Period dropdown",
      //     "Bottler selection search",
      //     "Bottler selection dropdown",
      //     "Upload Template",
      //   ],
      // },
      // {
      //   category: "Template Configuration",
      //   functionalities: [
      //     "Set Column Positions by File Upload",
      //     "Template Configuration Selection",
      //     "Template Configuration Save",
      //     "Template Configuration Delete",
      //   ],
      // },
      // {
      //   category: "Manual Update",
      //   functionalities: ["Manual Update Save"],
      // },
      // {
      //   category: "Excel Update",
      //   functionalities: ["Excel Download", "Excel Upload"],
      // },
    ],
    additionalFields: {},
  },
  {
    menu: "FG Inventory",
    subMenu: "Metrics",
    categories: [
      {
        category: "FG Inventory Tracker",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "Forecast Submission status",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
        ],
      },
      {
        category: "FG Inventory Performance History",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
          "Forecast submission by Month",
        ],
      },
      // {
      //   category: "FG Inventory Error Performance",
      //   functionalities: [
      //     "Forecast period dropdown",
      //     "Bottler dropdown",
      //     "Country dropdown",
      //     "Region dropdown",
      //     "Most Frequent Errors",
      //     "Error Performance details by Bottler",
      //   ],
      // },
    ],
    additionalFields: {},
  },
  // Business Planning
  {
    menu: "Bottler Business Plan",
    subMenu: "Dashboard",
    categories: [
      {
        category: "Business Plan Upload Dashboard",
        functionalities: ["Blank Page"],
      },
      {
        category: "Bottler Business Plan Upload Status",
        functionalities: ["Submission Status"],
      },
      {
        category: "Bottler Selection",
        functionalities: [
          "Bottler owner code selection",
          "Country dropdown and selection",
          "Search",
          "Bottler dropdown and selection",
        ],
      },
      {
        category: "Previous Bottler Business Plan Uploads",
        functionalities: [
          "View all history",
          "Upload Status",
          "Upload record Count",
          "View Button",
        ],
      },
      {
        category: "Record detail",
        functionalities: [
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Bottler Business Plan",
    subMenu: "History",
    categories: [
      {
        category: "Bottler Plan History",
        functionalities: [
          "Upload Status",
          "Upload record Count",
          "View Button",
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Bottler Business Plan",
    subMenu: "Manage Plan",
    categories: [
      {
        category: "Standard Coke Template",
        functionalities: [
          "Business Plan Period dropdown",
          "Bottler selection search",
          "Bottler selection dropdown",
          "Download Template",
          "Upload Template",
        ],
      },
      // {
      //   category: "Custom Coke Template",
      //   functionalities: [
      //     "Forecast Period dropdown",
      //     "Bottler selection search",
      //     "Bottler selection dropdown",
      //     "Upload Template",
      //   ],
      // },
      // {
      //   category: "Template Configuration",
      //   functionalities: [
      //     "Set Column Positions by File Upload",
      //     "Template Configuration Selection",
      //     "Template Configuration Save",
      //     "Template Configuration Delete",
      //   ],
      // },
      // {
      //   category: "Manual Update",
      //   functionalities: ["Manual Update Save"],
      // },
      // {
      //   category: "Excel Update",
      //   functionalities: ["Excel Download", "Excel Upload"],
      // },
    ],
    additionalFields: {},
  },
  {
    menu: "Bottler Business Plan",
    subMenu: "Metrics",
    categories: [
      {
        category: "Business Plan Tracker",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "Forecast Submission status",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
        ],
      },
      {
        category: "Business Plan Performance History",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
          "Forecast submission by Month",
        ],
      },
      // {
      //   category: "Business Plan Error Performance",
      //   functionalities: [
      //     "Forecast period dropdown",
      //     "Bottler dropdown",
      //     "Country dropdown",
      //     "Region dropdown",
      //     "Most Frequent Errors",
      //     "Error Performance details by Bottler",
      //   ],
      // },
    ],
    additionalFields: {},
  },
  // Concentrate Inventory
  {
    menu: "Concentrate Inventory",
    subMenu: "Dashboard",
    categories: [
      {
        category: "Concentrate Inventory Upload Dashboard",
        functionalities: ["Blank Page"],
      },
      {
        category: "Concentrate Inventory Upload Status",
        functionalities: ["Submission Status"],
      },
      {
        category: "Bottler Selection",
        functionalities: [
          "Bottler owner code selection",
          "Country dropdown and selection",
          "Search",
          "Bottler dropdown and selection",
        ],
      },
      {
        category: "Previous Concentrate Inventory Uploads",
        functionalities: [
          "View all history",
          "Upload Status",
          "Upload record Count",
          "View Button",
        ],
      },
      {
        category: "Record detail",
        functionalities: [
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Concentrate Inventory",
    subMenu: "History",
    categories: [
      {
        category: "Concentrate Inventory History",
        functionalities: [
          "Upload Status",
          "Upload record Count",
          "View Button",
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Concentrate Inventory",
    subMenu: "Target Days of Supply",
    categories: [
      {
        category: "Concentrate Inventory Target Days of Supply",
        functionalities: [
          "Bottler Owner Code dropdown",
          "Target Days of Supply input field",
          "Status column",
          "Save button",
          "Download button",
          "Upload button",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Concentrate Inventory",
    subMenu: "Manage Concentrate Inventory",
    categories: [
      {
        category: "Standard Coke Template",
        functionalities: [
          "Concentrate Inventory Period dropdown",
          "Bottler selection search",
          "Bottler selection dropdown",
          "Download Template",
          "Upload Template",
        ],
      },
      // {
      //   category: "Custom Coke Template",
      //   functionalities: [
      //     "Forecast Period dropdown",
      //     "Bottler selection search",
      //     "Bottler selection dropdown",
      //     "Upload Template",
      //   ],
      // },
      // {
      //   category: "Template Configuration",
      //   functionalities: [
      //     "Set Column Positions by File Upload",
      //     "Template Configuration Selection",
      //     "Template Configuration Save",
      //     "Template Configuration Delete",
      //   ],
      // },
      // {
      //   category: "Manual Update",
      //   functionalities: ["Manual Update Save"],
      // },
      // {
      //   category: "Excel Update",
      //   functionalities: ["Excel Download", "Excel Upload"],
      // },
    ],
    additionalFields: {},
  },
  {
    menu: "Concentrate Inventory",
    subMenu: "Metrics",
    categories: [
      {
        category: "Concentrate Inventory Tracker",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "Forecast Submission status",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
        ],
      },
      {
        category: "Concentrate Inventory Performance History",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
          "Forecast submission by Month",
        ],
      },
      // {
      //   category: "Concentrate Inventory Error Performance",
      //   functionalities: [
      //     "Forecast period dropdown",
      //     "Bottler dropdown",
      //     "Country dropdown",
      //     "Region dropdown",
      //     "Most Frequent Errors",
      //     "Error Performance details by Bottler",
      //   ],
      // },
    ],
    additionalFields: {},
  },
  //Production Requirement
  {
    menu: "Production Requirement",
    subMenu: "Dashboard",
    categories: [
      {
        category: "Production Requirement Upload Dashboard",
        functionalities: ["Blank Page"],
      },
      {
        category: "Production Requirement Upload Status",
        functionalities: ["Submission Status"],
      },
      {
        category: "Bottler Selection",
        functionalities: [
          "Bottler owner code selection",
          "Country dropdown and selection",
          "Search",
          "Bottler dropdown and selection",
        ],
      },
      {
        category: "Previous Production Requirement Uploads",
        functionalities: [
          "View all history",
          "Upload Status",
          "Upload record Count",
          "View Button",
        ],
      },
      {
        category: "Record detail",
        functionalities: [
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Production Requirement",
    subMenu: "History",
    categories: [
      {
        category: "Production Requirement History",
        functionalities: [
          "Upload Status",
          "Upload record Count",
          "View Button",
          "Failed Rows check box",
          "Successful rows Check box",
          "Download",
        ],
      },
    ],
    additionalFields: {
      bottler: true,
      forecastPartner: true,
      plant: false,
      profitCenter: true,
    },
  },
  {
    menu: "Production Requirement",
    subMenu: "Manage Production Requirement",
    categories: [
      {
        category: "Standard Coke Template",
        functionalities: [
          "Production Requirement Period dropdown",
          "Bottler selection search",
          "Bottler selection dropdown",
          "Download Template",
          "Upload Template",
        ],
      },
      // {
      //   category: "Custom Coke Template",
      //   functionalities: [
      //     "Forecast Period dropdown",
      //     "Bottler selection search",
      //     "Bottler selection dropdown",
      //     "Upload Template",
      //   ],
      // },
      // {
      //   category: "Template Configuration",
      //   functionalities: [
      //     "Set Column Positions by File Upload",
      //     "Template Configuration Selection",
      //     "Template Configuration Save",
      //     "Template Configuration Delete",
      //   ],
      // },
      // {
      //   category: "Manual Update",
      //   functionalities: ["Manual Update Save"],
      // },
      // {
      //   category: "Excel Update",
      //   functionalities: ["Excel Download", "Excel Upload"],
      // },
    ],
    additionalFields: {},
  },
  {
    menu: "Production Requirement",
    subMenu: "Metrics",
    categories: [
      {
        category: "Production Requirement Tracker",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "Forecast Submission status",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
        ],
      },
      {
        category: "Production Requirement Performance History",
        functionalities: [
          "Forecast period dropdown",
          "Bottler dropdown",
          "Country dropdown",
          "Region dropdown",
          "% button",
          "Count button",
          "Forecast Submission Detail by Bottler",
          "Forecast submission by Month",
        ],
      },
      // {
      //   category: "Production Requirement Error Performance",
      //   functionalities: [
      //     "Forecast period dropdown",
      //     "Bottler dropdown",
      //     "Country dropdown",
      //     "Region dropdown",
      //     "Most Frequent Errors",
      //     "Error Performance details by Bottler",
      //   ],
      // },
    ],
    additionalFields: {},
  },
  // ===== Others =====
  {
    menu: "Others",
    subMenu: null,
    categories: [],
    additionalFields: {},
  },
];

export {
  getMenuListApplicableForSupport,
  getCategoryList,
  getFunctionalityList,
  getApplicableAdditionalFields,
  getSubmenuListForMenu,
};
